import React from "react";
import SkinHairtreatments from "../assets/img/treatments/SkinHairtreatments.PNG";
import {
  microneedlingPreCare,
  facialAfterCare,
  faceMicroneedlingAfterCare,
  scalpMicroneedlingAfterCare,
} from "../data/preCareInstructions";

const MicroneedlingCare = () => {
  return (
    <>
      <h1 className="md:text-5xl text-3xl justify-center flex my-8 m-auto p-2">
        Facial, Skin & Scalp Microneedling Care
      </h1>

      <div className="flex flex-col-reverse md:mx-12 my-8 lg:flex-row flex-wrap items-start">
        <div className="w-full lg:w-3/5 pr-4 my-8 lg:mb-0">
          <div className="mb-6 p-8 ">
            <h2 className="md:text-3xl text-xl font-semibold mb-8 text-black">
              Before & After Care - Facial, Skin & Scalp Microneedling Treatments
            </h2>
            <p className="text-base leading-loose text-gray-800 lora-font">
              To achieve the best results from your microneedling treatments, 
              following proper before and after care is essential. These guidelines 
              will help prepare your skin and scalp for treatment and ensure optimal 
              healing and results. Individual responses may vary, and your commitment 
              to proper care is crucial for achieving the desired outcomes.
            </p>
          </div>
        </div>
        <div className="w-full lg:w-2/5 p-4 md:p-0 md:pl-4 md:my-8 lg:mb-0">
          <img
            src={SkinHairtreatments}
            alt="Microneedling Treatment"
            className="rounded-lg shadow-lg w-[600px] h-[400px] object-cover mx-auto lg:mx-0"
          />
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg">
          <div className="flex flex-col-reverse lg:flex-row flex-wrap items-start">
            <div className="w-full pr-4 mb-8 lg:mb-0">
              <div className="mb-6">
                <h2 className="text-4xl font-semibold mb-4 text-black flex items-center">
                 Before Your Treatment
                </h2>
                <p className="text-base leading-7 text-gray-800 mb-4">
                  To prepare your skin and scalp for the best results:
                </p>
                <ul className="list-disc list-inside leading-loose">
                  {microneedlingPreCare.map((instruction, index) => (
                    <li key={index} className="mb-2">
                      {instruction}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-4 p-6 md:mx-12 mx-4">
        <h2 className="my-4 text-4xl font-semibold text-black flex items-center">
        After Facial Treatments
        </h2>
        <ul className="list-disc list-inside mb-6 leading-loose">
          {facialAfterCare.map((instruction, index) => (
            <li key={index} className="mb-2">
              {instruction}
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-gradient-to-r from-primary via-white to-primary md:mx-12 p-12 mt-8">
        <div className="bg-white p-8 shadow-lg">
          <h2 className="text-4xl font-semibold mb-4 text-black flex items-center">
      After Microneedling (Face)
          </h2>
          <ul className="list-disc list-inside mb-6 leading-loose">
            {faceMicroneedlingAfterCare.map((instruction, index) => (
              <li key={index} className="mb-2">
                {instruction}
              </li>
            ))}
          </ul>
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Results:</h3>
            <p className="text-base text-gray-800 mb-2">
              Visible improvement within 5-7 days, full collagen regeneration in 4-6 weeks.
            </p>
            <p className="text-base text-gray-800">
              <span className="font-semibold">✨ For best results:</span> 3-6 sessions, spaced 4 weeks apart.
            </p>
          </div>
        </div>
      </div>

      <div className="my-4 p-6 md:mx-12 mx-4">
        <h2 className="my-4 text-4xl font-semibold text-black flex items-center">
           After Scalp Microneedling (Hair & Follicle Therapy)
        </h2>
        <ul className="list-disc list-inside mb-6 leading-loose">
          {scalpMicroneedlingAfterCare.map((instruction, index) => (
            <li key={index} className="mb-2">
              {instruction}
            </li>
          ))}
        </ul>
        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h3 className="text-xl font-semibold mb-2 text-gray-800">Results:</h3>
          <p className="text-base text-gray-800 mb-2">
            Reduced shedding and improved hair texture are noticeable after 2-3 sessions;
          </p>
          <p className="text-base text-gray-800">
            thicker and denser regrowth develops over 2-3 months.
          </p>
        </div>
      </div>
    </>
  );
};

export default MicroneedlingCare;